<template>
  <div id="app">
    <head-Back title="分享"></head-Back>
    <div class="page">
      <div class="page-button">
        <div class="share-left" @click="shareApp(1)">
          <img src="../../assets/img/toshar-wx.png" />
          <br />
          <button>微信邀请</button>
        </div>
        <div class="share-right" @click="shareApp(2)">
          <img src="../../assets/img/toshare-dx.png" />
          <br />
          <button>短信</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import headBack from "../common/head-back";
import api from "../../api/index";
import wxapi from "../../utils/wxapi";
import store from "@/store";
import * as types from "../../store/types";
import { mapGetters } from "vuex";
import tips from "@/estoast";

export default {
  metaInfo: {
    title: "管理中心"
  },
  name: "app",
  data() {
    return {
      msg: "注册协议",
      shareConfigdata: null,
      link: "",
      invitationCode: "invitationCode",
      dlink: ""
    };
  },
  mounted() {
    this.$point.init(new Date());
    store.dispatch("hideLoading");
  },
  methods: {
    copy(e) {
      console.log(e.text);
      tips.toast("复制成功，快去黏贴分享吧");
    },
    onError(e) {
      console.log(e);
      tips.toast("复制失败");
    },
    shareApp(type) {
      var userInfo = this.getUserInfo;
      var url = "http%3A%2F%2Fwap.haoyunba.com%2F%23%2Fshare%3Ftype%3D"+type+"%26shareid%3D"+ userInfo.id;
      var msg = "你的兄弟邀请您使用好运吧。只有好兄弟才会推荐给你用的特殊APP！";
      var title = "一个懂事的聊天APP";
      console.log(url);

      if (type == 2) {
        var data = {
          url:"http://wap.haoyunba.com/#/share?type="+type+"&shareid="+ userInfo.id
        };

        this.$axiosHttp({
          method: "POST",
          url: api.qml.getdwz,
          data: data
        })
          .then(res => {
            //console.log("发送验证码结果" + JSON.stringify(res));
            if (res.code == 0) {
              console.log(res.result);
              msg =
                "你的兄弟邀请您使用好运吧。只有好兄弟才会推荐的特殊APP！点击 " +
                res.result +
                " 立即使用！";
              window.location.href =
                "hqml://share?shareType=" +
                type +
                "&message=" +
                msg +
                "&title=&url=" +
                url;
            } else {
              tips.toast(res.message);
            }
          })
          .catch(err => {
            tips.toast(err);
            console.log(err);
          });
      } else {
        window.location.href =
          "hqml://share?shareType=" +
          type +
          "&message=" +
          msg +
          "&title=" +
          title +
          "&url=" +
          url;
      }
    },
    toshareWx() {
      var data = this.shareConfigdata;
    },
    share() {
      var msg = "你我的亲密空间";
      if (num == 2) {
        msg = "你的好友邀请你使用亲密聊APP，点击立即开始你们的亲密聊天";
      }
      //获取微信data数据，分享数据
      let url = window.location.href;
      this.link = url;
      var data = {
        url: this.link
      };
      this.$axiosHttp({
        method: "POST",
        url: api.qml.wxgetShareConfig,
        data: data
      })
        .then(res => {
          //console.log("发送验证码结果" + JSON.stringify(res));
          if (res.code == 0) {
            console.log(res.result);
            this.shareConfigdata = res.result;
          } else {
            tips.toast(res.message);
          }
        })
        .catch(err => {
          tips.toast(err);
          console.log(err);
        });

      var userInfo = this.getUserInfo;
      this.invitationCode = window.location.host + "/#/share/1/" + userInfo.id;
      console.log(this.invitationCode);
      let opstion = {
        title: "一个懂事的聊天APP", // 分享标题
        link: window.location.href,
        imgUrl: "../../assets/img/logo-hyb.png", // 分享图标
        dec: "你的兄弟邀请您使用好运吧。只有好兄弟才会推荐给你用的特殊APP！",
        success: function() {},
        error: function() {}
      };
      wxapi.wxRegister(this.shareConfigdata, option);
    },
    toShareDx() {
      var phone = "";
      //发送短信的内容
      var name = "分享至";
      var u = navigator.userAgent,
        app = navigator.appVersion;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
      var isiOS =
        !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || u.indexOf("iPhone") > -1; //ios终端
      if (isAndroid) {
        var sendcontent = "sms:" + phone + "?body=" + name; //android  ///
        window.location.href = sendcontent;
      } else if (isiOS) {
        var sendcontent = "sms:" + phone + "&body=" + name; //ios  ///
        window.location.href = sendcontent;
      } else {
        var sendcontent = "sms:" + phone + "?body=" + name; //android  ///
        window.location.href = sendcontent;
      }
    }
  },
  components: {
    headBack
  },
  computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getUserList"
    ])
  }
};
</script>
<style  scoped>
.page {
  width: 750px;
  height: 2050px;
  background: url("../../assets/img/toshare-back@2x.png");
  background-size: cover;
  white-space: nowrap;
  overflow: hidden;
}

.share-left,
.share-right {
  width: 157px;
  height: 200px;
  float: left;
  margin-top: 1307px;
}

.share-left {
  margin-left: 155px;
}
.share-right {
  margin-left: 152px;
}
.share-left img,
.share-right img {
  width: 90px;
  height: 90px;
}

.share-left button,
.share-right button {
  width: 157px;
  height: 55px;
  background: rgba(255, 212, 79, 1);
  border-radius: 28px;
  font-size: 24px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: rgba(125, 60, 2, 1);
  line-height: 55px;
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/page/toshareApp.vue